var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"title-program-wrapper",attrs:{"to":_vm.to}},[_c('ImageResponsive',{attrs:{"imageUrl":_vm.image,"fromUrl":true,"width":"100","height":"100"}}),_vm._v(" "),_c('h1',{staticClass:"title-program"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }